import { render, staticRenderFns } from "./leave-requests.vue?vue&type=template&id=fb050ab0&scoped=true&"
import script from "./leave-requests.vue?vue&type=script&lang=js&"
export * from "./leave-requests.vue?vue&type=script&lang=js&"
import style0 from "./leave-requests.vue?vue&type=style&index=0&id=fb050ab0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb050ab0",
  null
  
)

export default component.exports